module.exports = "\r\n\r\n<div *ngIf=\"!$store.currentUser\">\r\n <app-landing-page></app-landing-page>\r\n</div>\r\n\r\n<div *ngIf=\"$store.currentUser\">\r\n    <app-search-bar></app-search-bar>\r\n    <!-- <router-outlet></router-outlet> -->\r\n    <app-display-profiles *ngIf=\"!this.$store.router.profile\"></app-display-profiles>\r\n    <app-profile *ngIf=\"this.$store.router.profile\"></app-profile>\r\n</div>"


//////////////////
// WEBPACK FOOTER
// C:/Users/Elise/essaiGit3/Converteo-Referentiel-RH/public/src/app/app.component.html
// module id = ../../../../../src/app/app.component.html
// module chunks = main